import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { assertBrowserEnvironment } from "./lib/runtime";
import { TimeZoneProvider } from "./lib/TimeZoneContext";
import "./styles.css";

assertBrowserEnvironment();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TimeZoneProvider><App /></TimeZoneProvider>
  </StrictMode>
);
